import { useEffect, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

import { PAGES_THRESHOLD, ObservedRoutes } from 'app/App/constants';

export const useObservedRoutes = () => {
  const [observedRoutes, setObservedRoutes] = useState(ObservedRoutes);
  const location = useLocation();

  useEffect(() => {
    if (observedRoutes.length === PAGES_THRESHOLD) {
      return;
    }

    const matchingIndex = observedRoutes.findIndex(locationItem =>
      matchPath(locationItem, location.pathname),
    );

    if (matchingIndex !== -1) {
      const observedRoutesCopy = [...observedRoutes];
      observedRoutesCopy.splice(matchingIndex, 1);

      setObservedRoutes(observedRoutesCopy);
    }
  }, [location.pathname, observedRoutes]);

  return observedRoutes;
};
